import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List, Icon } from 'antd'

import CollectionType from './CollectionType'

@inject((store: any) => {
    const { popupStore, collectionTypesStore } = store
    return { popupStore, collectionTypesStore }
})
@observer
export default class CollectionTypesPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }
    closePopup = () => {
        // this.props.servicefieldsStore.resetEdit()
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, collectionTypesStore } = this.props
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        return (
            <Modal
                title={'עריכת סוגי זכויות'}
                visible={popupStore.popupType === 'editCollectionTypes'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <Input.Search
                    value={collectionTypesStore.filters.name}
                    placeholder="הזן ערך לחיפוש תחום שירות"
                    onChange={e => collectionTypesStore.setFilter('name', e.target.value)}
                />
                <div style={{ paddingBottom: '2rem' }}>
                    <CollectionType collectionType={{ id: 'add', name: undefined }} />
                    <List
                        dataSource={collectionTypesStore.filteredList}
                        pagination={{ pageSize: 10 }}
                        renderItem={item => (
                            <List.Item style={{ padding: '0' }}>
                                <CollectionType collectionType={item} />
                            </List.Item>
                        )}
                    />
                </div>
            </Modal>
        )
    }
}
